export const payRecordStatusOptions = [
  {label: '未支付', value: 0},
  {label: '已支付', value: 1},
  {label: '已超时', value: 10},
  {label: '发起支付失败', value: 11},
];


export const payRecordStatusEnum = {
  notPay: 0,
  success: 1,
  timeout: 10,
  startPayFail: 11
}
